<template>
  <div class="d-flex row">
    <div class="col-sm-15 col-xl-15">
      <div class="p-4 mt-4 alert-color mx-4">
        <h3>{{reservationMessage()}}</h3>
        <button
          class="btn shadow justify-content-center align-items-center"
          @click="makeAnotherBooking()"
          style="margin-top:10px;"
          :style="Styles.btn"
        >Make another booking</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    Styles: {
      type: Object,
      default: function() {
        return {};
      }
    },
    reservationInfo: {
      type: Object,
      default: function() {
        return {
          venueInfo: {
            ViewComponentConfigs: {
              ReservationSubmittedMessage:
                "Thank you, your reservation request has been submitted."
            }
          }
        };
      }
    }
  },
  methods: {
    makeAnotherBooking() {
      this.$parent.configurationInfo.wizardIndex = 0;
      this.$parent.venueChanged(
        this.$parent.reservationInfo.venueInfo.Company_ID
      );
      this.$parent.guestInfo = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        countryIso: "AU",
        cardNumber: "",
        yearMonth: "",
        cvv: "",
        note: ""
      };
      this.$parent.termsAndCondiitonChk = false;
    },
    reservationMessage() {
      var message;
      var cfg = this.reservationInfo.venueInfo.ViewComponentConfigs;
      if (cfg) {
        message = cfg.ReservationSubmittedMessage;
      }
      if (!message)
        message = "Thank you, your reservation request has been submitted.";
      return message;
    }
  }
};
</script>